var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWedeliver4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_2714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3C3.5 2.17031 2.82969 1.5 2 1.5C1.17031 1.5 0.5 2.17031 0.5 3V18.75C0.5 20.8219 2.17812 22.5 4.25 22.5H23C23.8297 22.5 24.5 21.8297 24.5 21C24.5 20.1703 23.8297 19.5 23 19.5H4.25C3.8375 19.5 3.5 19.1625 3.5 18.75V3ZM22.5594 7.05938C23.1453 6.47344 23.1453 5.52188 22.5594 4.93594C21.9734 4.35 21.0219 4.35 20.4359 4.93594L15.5 9.87656L12.8094 7.18594C12.2234 6.6 11.2719 6.6 10.6859 7.18594L5.43594 12.4359C4.85 13.0219 4.85 13.9734 5.43594 14.5594C6.02188 15.1453 6.97344 15.1453 7.55938 14.5594L11.75 10.3734L14.4406 13.0641C15.0266 13.65 15.9781 13.65 16.5641 13.0641L22.5641 7.06406L22.5594 7.05938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_2714"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H24.5V24H0.5V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWedeliver4);
export default __webpack_public_path__ + "static/media/wedeliver4.2c51be8971b2c7c28b8465d8a082723d.svg";
export { ForwardRef as ReactComponent };